import { SocketTopics } from "@shared/types";
import useSocket from "@shared/features/socket/useSocket";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { updateNotificationsData } from "@shared/features/notifications/utils";
import { socketsSlices } from "@shared/slices/sockets.slice";

const useSocketNotifications = () => {
  const socketData = useSocket<SocketTopics.NOTIFICATIONS>(
    SocketTopics.NOTIFICATIONS,
    undefined
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (socketData?.value) {
      dispatch(
        socketsSlices[SocketTopics.NOTIFICATIONS].actions.updateSocketData(
          undefined
        )
      );
      dispatch(updateNotificationsData(socketData.value) as any);
    }
  }, [socketData]);
};

export default useSocketNotifications;
